export default __webpack_public_path__ + "static/media/gallery_06.c95fe734.jpg";